export const ROUTES = {
  writeBackManagement: {
    parentPath: "/clinical-coding",
    slug: "write-back-management",
    route: "/clinical-coding/write-back-management",
  },
};
